import {
    ADD_TO_USER,
    DELETE_USER
  } from "../actions/userAction";
  
  const initState = null;
  
  const userReducer = (state = initState, action) => {
    switch (action.type) {
      case ADD_TO_USER:
        return action.payload;
  
      case DELETE_USER:
        return null;
  
      default:
        return state;
    }
  };
  
  export default userReducer;
  